import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewPCategory, UpdatePCategory } from "../../Services/pcategory-service";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { isAlphanumeric, isAlphanumericWithDotSpaceDashCommaBrackets, isNumber } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import ButtonModal from "../Modals/buttonModal";

const AddEditPCategoryMaster = (props) => {
  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }

  let action = props.action;
  let formName = "P Category";
  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const toggle = props.rowdata.wld_status === false ? "InactiveToggleLabel" : "activeToggleLabel";
  const [toggleClass, setToggleClass] = useState(action === "Edit" ? toggle : "activeToggleLabel");
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");

  const [PCategoryObj, setPCategoryObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_p_category: "",
        wld_material: "",
        SK: "",
        PK: "PCategory",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );
  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_p_category: {},
    wld_material: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setPCategory",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPCategoryObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setPCategoryObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setPCategoryObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_p_category: "",
        wld_material: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
      }));
    } else if (action === "Edit") {
      setPCategoryObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_p_category: props.rowdata.wld_p_category,
        wld_material: props.rowdata.wld_material,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
      }));
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_p_category: {},
      wld_material: {},
      SK: {},
    }));
  };

  const validatePCategory = (action) => {
    let result = false;
    let isError = false;
    if (PCategoryObj.wld_code.trim() === "") {
      PCategoryObj.wld_code = "";
      isError = true;
      error.wld_code = {
        status: true,
        message: "P Category Number is required.",
      };
    }
    if (PCategoryObj.wld_p_category.trim() === "") {
      PCategoryObj.wld_p_category = "";
      isError = true;
      error.wld_p_category = {
        status: true,
        message: "P Category is required.",
      };
    }
    if (PCategoryObj.wld_material.trim() === "") {
      PCategoryObj.wld_material = "";
      isError = true;
      error.wld_material = {
        status: true,
        message: "Material is required.",
      };
    }
    if (PCategoryObj.wld_status === "") {
      isError = true;
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }

    if (action === "Add") {


      result =
        props.allRecs &&
        props.allRecs.find(
          (item) =>
            item.PK.toLowerCase() === PCategoryObj.PK.toLowerCase() &&
            item.SK.toLowerCase() === PCategoryObj.wld_code.toLowerCase()
        );
    }

    if (result) {
      setAlertMessage("P Category Number Already Exists!");
      isError = true;
    }
    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (
      error.SK.status ||
      error.wld_code.status ||
      error.wld_p_category.status ||
      error.wld_material.status
    ) {
      isError = true;
    }
    return isError;
  };
  const handleAdd = (e) => {
    let result;
    if (PCategoryObj.wld_status === true) {
      PCategoryObj.wld_status = "Active";
    } else {
      PCategoryObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      PCategoryObj.SK = PCategoryObj.wld_code;
      PCategoryObj.wld_createdby = username;

      result = AddNewPCategory(PCategoryObj);
    } else {
      PCategoryObj.wld_updatedby = PCategoryObj.wld_createdby;

      result = UpdatePCategory(PCategoryObj);
    }
    result
      .then((resp) => {
        if (action === "Edit") {
          showSuccess(`Selected P Category has been Updated successfully`);
        }
        if (resp.message === "Duplicate") {
          showWarning(resp.message);
        } else if (action === "Add") {
          showSuccess(`Selected P Category has been Added successfully`);
        }
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
      .catch((error) => {
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validatePCategory(action)) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed P Category successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} P Category</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        disabled={action === "Edit" ? true : false}
                        maxLength="4"
                        className={
                          error.wld_code.status
                            ? "  placeHolderInput inputText text-field-with-error allow"
                            : " placeHolderInput inputText allow"
                        }
                        value={PCategoryObj.wld_code}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumeric(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        P Number{" "}
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                  </Form.Group>
                  {error.wld_code.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "30px" }}>
                        {error.wld_code.message}
                      </span>{" "}
                    </Form.Text>
                  )}
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_p_category"
                        name="wld_p_category"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_p_category.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={PCategoryObj.wld_p_category}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumber(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_p_category: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_p_category">
                        P Category
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                  </Form.Group>
                  {error.wld_p_category.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "30px" }}>
                        {error.wld_p_category.message}
                      </span>{" "}
                    </Form.Text>
                  )}
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_material"
                        name="wld_material"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_material.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={PCategoryObj.wld_material}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error =
                            isAlphanumericWithDotSpaceDashCommaBrackets(
                              e.target.value
                            );
                          setError((prevState) => ({
                            ...prevState,
                            wld_material: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_material">
                        Material
                      </Form.Label>
                    </div>
                  </Form.Group>
                  {error.wld_material.status && (
                    <Form.Text className="text-danger">
                      <span style={{ position: "relative", bottom: "8px" }}>
                        {error.wld_material.message}
                      </span>{" "}
                    </Form.Text>
                  )}
                </Col>
                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={PCategoryObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {PCategoryObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>
          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>
          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddEditPCategoryMaster;